(() => {
  const label = document.currentScript?.dataset.reviewDetailsLabel?.trim();
  if (!label) return;

  const linkSelector = 'a.jdgm-popup-card__full-rev-link';
  const patchLinks = (root) => {
    root.querySelectorAll(linkSelector).forEach((link) => {
      if (
        !link.textContent.trim() &&
        !link.getAttribute('aria-label')?.trim() &&
        !link.getAttribute('aria-labelledby')?.trim()
      ) {
        link.setAttribute('aria-label', label);
      }
    });
  };

  const watchPopup = (popup) => {
    patchLinks(popup);
    new MutationObserver(() => patchLinks(popup)).observe(popup, {
      childList: true,
      subtree: true,
    });
  };

  const popup = document.querySelector('.jdgm-popup-widget');
  if (popup) {
    watchPopup(popup);
    return;
  }

  const mountObserver = new MutationObserver((records) => {
    for (const record of records) {
      for (const node of record.addedNodes) {
        if (node.nodeType !== Node.ELEMENT_NODE) continue;
        const popup = node.matches('.jdgm-popup-widget')
          ? node
          : node.querySelector('.jdgm-popup-widget');
        if (popup) {
          mountObserver.disconnect();
          watchPopup(popup);
          return;
        }
      }
    }
  });
  mountObserver.observe(document.body, { childList: true, subtree: true });
})();
